import { useState } from 'react';
import { useInstallPrompt } from '@/hooks/useInstallPrompt';

export function InstallBanner() {
  const { canInstall, isIos, promptInstall } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(false);

  if (!canInstall || dismissed) return null;

  return (
    <div className="install-banner">
      {isIos ? (
        <span>
          Tap{' '}
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle' }}>
            <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
            <polyline points="16 6 12 2 8 6" />
            <line x1="12" y1="2" x2="12" y2="15" />
          </svg>{' '}
          then "Add to Home Screen"
        </span>
      ) : (
        <span>Install MacroRides for a better experience</span>
      )}
      <div className="install-banner-actions">
        {!isIos && (
          <button className="install-btn" onClick={promptInstall}>
            Install
          </button>
        )}
        <button className="dismiss-btn" onClick={() => setDismissed(true)}>
          {isIos ? 'OK' : 'Not now'}
        </button>
      </div>
    </div>
  );
}
